import React, {useState} from 'react';
import {lighten} from "@mui/material/styles";
import {withStyles} from "@mui/styles";
import {Card, Checkbox, IconButton} from '@mui/material';
import {OpenIcon, TagIcon} from '../../../../../helpers/Icons'
import UploadThumbnail from "./UploadThumbnail";
import {openLinkStyle} from "../../../../util/data-table/list-view/DataListView";
import ItemTypeIcon from "../../../../../helpers/ItemTypeIcon";
import MindfileAvatarTopBar from "./MindfileIAvatar";
import SurveyThumbnail from "./SurveyThumbnail";

const styles = (theme) => ({
  pendingButton:{
    padding:0
  },
  pendingIcon: {
    color: '#ffb506',
  },
  openLink: {
    ...openLinkStyle(''),
    fontWeight: '500',
    color: 'rgba(0,0,0,0.8)',
    width:'10dvw',
    minWidth: '8em',
    maxWidth: 'calc(max(10dvw, 15em))',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textDecoration:'underline'
  },
  card: {
    // padding:"0.5em",
    border: '1px solid rgba(0,0,0,0.12)',
    flexGrow:0,
    flexShrink:1,
    flexBasis: '300px',
    maxWidth: '300px',
    width: '300px',
    margin: 8,
    cursor: "pointer",
    boxSizing:'border-box',
  },
  cardMd: {
    flexBasis: '150px',
    maxWidth: '150px',
  },
  cardSm: {
    flexBasis: '72px',
    maxWidth: '72px',
  },
  highlight: {
    color: theme.palette.secondary.main,
    backgroundColor: lighten(theme.palette.secondary.light, 0.85),
  },
  root:{
    display:'flex',
    flexDirection:'column',
    gap: '0.5rem',
    overflow:'hidden',
    "&:hover input[type='checkbox'] + svg":{
      backgroundColor:"rgba(255,255,255,0.5)",
      opacity: 1,
    },
    "&:hover input[type='checkbox']:hover + svg":{
      backgroundColor:"rgba(255,255,255,0.8) !important"
    }
  },
  titleRight:{
    display: 'inline-flex',
    flexDirection: 'row',
    gap: '0.25rem 1rem',
    fontSize: '0.85em',
    marginLeft:'auto',
    alignSelf:'center',
    overflow:'hidden',
    paddingLeft:'1em',

  },
  title:{
    fontWeight:500,
    display:'flex',
    overflow:'hidden',
    color:'rgba(0, 0, 0, 0.87)',
    padding: '0.5em 0.5em 0 0.5em',
    flexWrap: 'nowrap',
    '& > svg':{
      color: '#005985',
      width: '1.5rem',
      height: '1.5rem',
      fontSize: 'inherit',
      // margin: '0.2em 0.35em 0 0',
      alignSelf: 'center',
    },
  },
  viewLink:{
    ...openLinkStyle('')
  },
  nameText:{
    whiteSpace:'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
    padding:'0 0.5em 0.25rem',
    fontWeight:400,
    fontSize:'1.25rem',
    textAlign:'center',
    textDecoration:'underline 1px',
    color: 'rgba(0,0,0,0.87)',
    maxWidth:'300px',
  },
  nameTextMd:{
    fontSize:'0.85rem',
    maxWidth:'150px',
    marginBottom: '0.5rem',
    '& span':{
      cursor: 'pointer',
    },
    '&:hover span':{
      opacity: 0.5
    }
  },
  nameTextSm:{
    fontSize:'0.7225rem',
    maxWidth:'72px',
    marginBottom: '0.75rem',
    '& span':{
      cursor: 'pointer',
    },
    '&:hover span':{
      opacity: 0.5
    }
  },
  checkbox:{
    alignItems:'start',
    height:'1em',
    padding:0,
    marginRight:'0.25em',
    zIndex: 10
  },
  body: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '1.5rem 1rem',
    position:'relative'

  },
  bodyMd:{
    margin:0
  },
  bodySm:{
    margin:0
  },
  content:{
    flexGrow:1,
    display: 'flex',
    flexDirection: 'column',
    // gap:'1.5em 0.5em',
    justifyContent:'space-between',
    position: "relative"
  },
  checkFloat:{
    position: "absolute",
    top: 2,
    left: 2,
    '& svg':{
      opacity: 0.5,
    },
    '& input:checked + svg':{
      opacity: 1,
    }
  },
  statusFloat:{
    position: "absolute",
    top: 2,
    right: 2
  },
  description:{
    fontWeight: 400,
    maxWidth:'300px',
    width:'300px',
    height:'300px',
    boxSizing:'border-box',
    borderTop: '1px solid rgba(0,0,0,0.12)',
    padding: '0.75rem',
    overflow:'hidden',
    whiteSpace:'pre-wrap',
    position:'relative',
    color: 'rgba(0,0,0,0.87)'
  },
  descriptionBG:{
    position:'absolute',
    top: 0,
    left: 0,
    width:'100% !important',
    height:'100% !important',
    opacity:0.15,
    color: '#42c0f4'
  },
  descriptionMd:{
    fontWeight: 400,
    fontSize: '0.85em',
    maxWidth:'150px',
    width:'150px',
    height:'150px',
    borderTop: 'none',
    padding: '0.5rem',
  },
  descriptionSm:{
    fontWeight: 400,
    fontSize: '0.7225em',
    maxWidth:'72px',
    width:'72px',
    height:'72px',
    borderTop: 'none',
    padding: '0.25rem',
  },
  date:{
    display: 'inline-block',
    whiteSpace: 'nowrap',
  },
  folder: {
    display:'inline-flex',
    flexDirection:'row',
    flexWrap:'nowrap',
    whiteSpace:'nowrap',
    gap:'0.35em',
    '& > svg':{
      fontSize: '20px',
      width:'0.85em',
      height:'0.85em',
      alignSelf:'center',
    }
  },
  folderLink: {
    whiteSpace:'nowrap',
    textDecoration:'underline',
    cursor:'pointer',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&:hover':{
      opacity:0.5,
    }
  },
  folderNoLink: {
    whiteSpace:'nowrap',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
});

function MindfileItemIcon(props) {
  const { iconSize, item, isSelected, onSelectItem, openDataView,
    mindfileUserLevel, mindfileDisplay, classes } = props;

  // const history = useHistory();
  const [hover, setHover] = useState(false);

  const statusIcon = () => {
    return item.status === 'pending' ? (
      // todo: icon small
      <IconButton id="statusCell" size="small" className={classes.pendingButton} onClick={openDataView}>
        <TagIcon size="small" className={classes.pendingIcon} />
      </IconButton>
    ) : null;
  }

  // const columnAction = (key) => {
  //   return !!columnMap ? columnMap[key]?.action || null : null;
  // };
  // const columnHidden = (key) => {
  //   return !!columnMap ? columnMap[key]?.viewHidden || false : false;
  // };

  const cardSize = iconSize === "Medium" ? classes.cardMd : iconSize === "Small" ? classes.cardSm : "";
  const descSize = iconSize === "Medium" ? classes.descriptionMd : iconSize === "Small" ? classes.descriptionSm : "";
  const nameSize = iconSize === "Medium" ? classes.nameTextMd : iconSize === "Small" ? classes.nameTextSm : "";
  const bodySize = iconSize === "Medium" ? classes.bodyMd : iconSize === "Small" ? classes.bodySm : "";
  const thumbSize = iconSize === "Medium" ? "mdic" : iconSize === "Small" ? "smic" : "lgic";

  return (
    <div key={item.id}>
      <Card className={isSelected ? `${classes.card} ${classes.highlight} ${cardSize}` : `${classes.card} ${cardSize}`}
        raised={hover}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={onSelectItem.bind(this, item.id)}
      >
        <MindfileAvatarTopBar
          item={item}
          size={iconSize}
          mindfileDisplay={mindfileDisplay}
        />
        <div className={classes.root}>
          <div className={classes.viewLink}>
            <div className={`${classes.body} ${bodySize}`}>
              <div className={classes.content} onClick={openDataView}>
                {mindfileUserLevel <= 2 ?
                  <>
                    <span id="selectedCell" className={classes.checkFloat}>
                      <Checkbox id="itemSelect" className={classes.checkbox} checked={isSelected} onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onSelectItem(e);
                      }} />
                    </span>
                    <span className={classes.statusFloat}>
                      {statusIcon()}
                    </span>
                  </>
                  : null
                }
                {item.item_data_type === 'Upload' ?
                  <UploadThumbnail item={item} size={thumbSize} thumbnailStyle={{border: 0, borderRadius: '0 0 4px 4px'}} />
                : <div id="descriptionCell" className={`${classes.description} ${descSize}`}>
                    <ItemTypeIcon item={item} className={classes.descriptionBG} />
                    { item.item_data_type === 'SurveyAttempt' ?
                      <SurveyThumbnail item={item} iconSize={iconSize}/>
                      : item.description
                    }
                  </div>
                }
              </div>
            </div>
            {iconSize === "Large" ? <OpenIcon onClick={openDataView}/> : null }
          </div>
        </div>
      </Card>
      <div className={`${classes.nameText} ${nameSize}`}>
        <span id="nameCell" onClick={openDataView}>{item.name}</span>
      </div>
    </div>
  );
}

export default withStyles(styles)(MindfileItemIcon);
